import { render, staticRenderFns } from "./AdministracionView.vue?vue&type=template&id=e4e43fda&"
import script from "./AdministracionView.vue?vue&type=script&lang=js&"
export * from "./AdministracionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports